import { Box, Typography, useTheme } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import moment from 'moment';
import React, { useMemo } from 'react';
import { RsvpSentStatsItem } from '../../../../types/dashboard';
import { CustomChip } from '../../../../../layout/styledcomponents/CustomChip';
import GenericTable from '../../../../shared/GenericTable';
import { getReportChipSx, getRsvpSentChipTone } from '../../reportChartConfig';
import { dashboardItemsTableDefaults } from '../../dashboardReportTableConfig';

type RsvpsSentBookingsListProps = {
    bookings: RsvpSentStatsItem[];
};

export default function RsvpsSentBookingsList({
    bookings,
}: RsvpsSentBookingsListProps) {
    const theme = useTheme();

    const columns: MRT_ColumnDef<RsvpSentStatsItem>[] = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'Reservation Ref',
                size: 120,
                Cell: ({ cell }) => `#${cell.getValue<number>()}`,
            },
            {
                accessorKey: 'guestCompany',
                header: 'Guest Company',
                size: 160,
            },
            {
                accessorKey: 'moduleName',
                header: 'Experience',
                size: 160,
            },
            {
                accessorKey: 'ownerName',
                header: 'Host',
                size: 140,
            },
            {
                id: 'rsvpEnabled',
                accessorFn: (row) => (row.rsvpEnabled ? 'Sent' : 'Not Sent'),
                header: 'RSVP Sent',
                size: 120,
                Cell: ({ cell }) => (
                    <CustomChip
                        label={cell.getValue<string>()}
                        sx={getReportChipSx(
                            getRsvpSentChipTone(
                                cell.getValue<string>() === 'Sent',
                            ),
                            theme,
                        )}
                        variant='outlined'
                    />
                ),
            },
            {
                accessorKey: 'createdAt',
                header: 'Created',
                size: 120,
                sortingFn: 'datetime',
                Cell: ({ cell }) =>
                    moment(cell.getValue<string>()).format('DD/MM/YYYY'),
            },
            {
                accessorKey: 'startDate',
                header: 'From',
                size: 110,
                sortingFn: 'datetime',
                Cell: ({ cell }) =>
                    moment(cell.getValue<string>()).format('DD/MM/YYYY'),
            },
            {
                accessorKey: 'endDate',
                header: 'To',
                size: 110,
                sortingFn: 'datetime',
                Cell: ({ cell }) =>
                    moment(cell.getValue<string>()).format('DD/MM/YYYY'),
            },
        ],
        [theme],
    );

    const rows = bookings ?? [];

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No individual guest bookings found for this selection.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardItemsTableDefaults}
                columns={columns}
                data={rows}
                tableName='RSVPs Sent Report'
                paginationItemLabel='bookings'
            />
        </Box>
    );
}
